import Vue from 'vue';

const data = {
  push: {
    titulo: '',
    body: '',
  },
  email: {
    titulo: '',
    body: '',
  },
  sms: {
    body: '',
  },
  dialog: false,
  sendPush: true,
  sendEmail: true,
  sendSms: true,
  payload: {
    alteradoPorId: '',
    alteradoPorNome: '',
    atualizadoEm: '',
    criadoEm: '',
    criadoPorId: '',
    criadoPorNome: '',
    dataAgendamento: '',
    descricao: '',
    emailConfigurado: '',
    enviadoPorId: '',
    enviadoPorNome: '',
    enviarEmail: '',
    enviarPush: '',
    enviarSms: '',
    excluidoPorId: '',
    excluidoPorNome: '',
    id: '',
    listaClientesIds: [],
    pushConfigurado: '',
    smsConfigurado: '',
    status: '',
    titulo: '',
    todos: '',
  },
  sendedOptions: [
    {
      text: 'Todos',
      value: 'all',
    },
    {
      text: 'Filtrados',
      value: 'filtered',
    },
    {
      text: 'Selecionados',
      value: 'selected',
    },
    {
      text: "Informar ID's",
      value: 'list',
    },
    {
      text: 'Clientes elegíveis',
      value: 'elegivel',
    },
  ],
  elegivelOptions: [
    {
      label: 'Todos',
      value: 'elegiveis',
    },
    {
      label: 'Empréstimos',
      value: 'elegiveisEmprestimo',
    },
    {
      label: 'Não contratantes',
      value: 'elegiveisNaoContratantes',
    },
    {
      label: 'Prorrogação',
      value: 'elegiveisProrrogacao',
    },
  ],
  sendedOption: 'filtered',
  elegivelOption: '',
  filtrosClientes: {},
  schedule: '',
  selectedCustomers: [],
};

const communicationData = new Vue({
  data() {
    return {
      ...data,
    };
  },
  computed: {
    elegiveisKeys() {
      return ['elegiveis', 'elegiveisEmprestimo', 'elegiveisNaoContratantes', 'elegiveisProrrogacao'];
    },
    getDataPayload() {
      const {
        email,
        push,
        sms,
        payload,
        sendedOption,
        elegivelOption,
        sendPush,
        sendEmail,
        sendSms,
        filtrosClientes,
        schedule,
        selectedCustomers,
      } = this;

      const { descricao, titulo, status } = payload;
      const override = {
        descricao,
        titulo,
        rascunho: status === 'RASCUNHO',
        todos: sendedOption === 'all',
        filtrosClientes: {},
        listaClientesIds: [],
      };

      switch (sendedOption) {
        case 'filtered': {
          override.filtrosClientes = filtrosClientes;
          break;
        }
        case 'selected': {
          override.listaClientesIds = selectedCustomers.map(
            ({ id }) => Number(id),
          );
          break;
        }
        case 'list': {
          override.listaClientesIds = payload.listaClientesIds;
          break;
        }
        case 'elegivel': {
          this.elegiveisKeys.forEach(
            (key) => {
              override[key] = elegivelOption === key;
            },
          );
          break;
        }
        default:
          break;
      }

      const hasFilterClients = Object.keys(override.filtrosClientes)
        .some(key => override.filtrosClientes && !!override.filtrosClientes[key]);

      if (!override.filtrosClientes || !hasFilterClients) {
        override.filtrosClientes = null;
      }

      const send = {
        dataAgendamento: status === 'AGENDADA' ? schedule : null,
        enviarEmail: sendEmail,
        enviarPush: sendPush,
        enviarSms: sendSms,
      };

      const body = {
        payload: override,
        send: ['ENVIADA', 'AGENDADA'].includes(status) ? send : null,
      };

      const notifications = {
        email,
        sms,
        push,
      };

      Object.keys(notifications)
        .forEach(
          (key) => {
            const notification = notifications[key];
            if (!!notification && this.hasMessage(notification, 'titulo', 'body')) {
              body[key] = notification;
            }
          },
        );


      return body;
    },
  },
  methods: {
    hasMessage(body, ...properties) {
      return properties.some(
        property => !!body[property],
      );
    },
    setData({
      push, email, sms, payload,
    }) {
      this.push = push;
      this.email = email;
      this.sms = sms;
      this.payload = payload;

      const { enviarPush, enviarSms, enviarEmail } = payload;
      this.sendEmail = enviarEmail;
      this.sendPush = enviarPush;
      this.sendSms = enviarSms;

      this.setSendedOption(payload);
    },
    setSendedOption(payload = {}) {
      if (payload.todos) {
        this.sendedOption = 'all';
        return;
      }

      if (payload.filtrosClientes) {
        this.sendedOption = 'filtered';
        return;
      }

      if (Array.isArray(payload.listaClientesIds) && payload.listaClientesIds.length >= 1) {
        this.sendedOption = 'list';
      }

      const {
        elegiveis, elegiveisEmprestimo, elegiveisNaoContratantes, elegiveisProrrogacao,
      } = payload;

      if (elegiveis || elegiveisEmprestimo || elegiveisNaoContratantes || elegiveisProrrogacao) {
        this.sendedOption = 'elegivel';

        this.elegiveisKeys
          .forEach(
            (key) => {
              if (payload[key]) {
                this.elegivelOption = key;
              }
            },
          );
      }
    },
    setKeyData(key, value) {
      this[key] = value;
    },
    load() {
      const override = { ...data };
      Object.keys(override).forEach(
        (key) => {
          this[key] = override[key];
        },
      );
    },
  },
});

export default communicationData;
